import { getResultConfig, updateResultConfig, getResultSetting, generateSEVResult, getSSNChannelTDRPowerSumResult } from "../../api/Rocky/rockyCtrl";
import WaveformResultHelper from '@/services/Rocky/result/helper/WaveformResultHelper';
import apiProcess from "../../api/utility";
import { PRELAYOUT } from "../preLayout/preLayoutConfig";

async function getPowerSumResultPromise({ type, id, pageType, fileList, isPcbPkgCascade }) {
	let waveform = new WaveformResultHelper("result");
	if (pageType === PRELAYOUT) {
		let data = [];
		for (let fileInfo of fileList) {
			const { libraryId } = fileInfo;
			let waveformData = await getSSNChannelTDRPowerSumResult({ type, verificationId: id, libraryId, option: "power-sum", isPcbPkgCascade: false });
			if (waveformData && waveformData.data) {
				data.push({ data: waveformData.data, libraryId })
			}
		}
		waveform.parsePreLayoutRawCurve(data);
	} else {
		let waveformData = (await getSSNChannelTDRPowerSumResult({ type, verificationId: id, option: "power-sum", isPcbPkgCascade }));
		waveform.parseRawCurve(waveformData && waveformData.data ? waveformData.data : "", [], false, false, true);
	}
	return waveform;
}

function getResultConfigPromise(verificationId, isPcbPkgCascade) {
	return apiProcess(getResultConfig, { verificationId, isPcbPkgCascade })
}

function updateResultConfigPromise({ verificationId, config, isPcbPkgCascade }) {
	return apiProcess(updateResultConfig, { verificationId, config, isPcbPkgCascade })
}

function getResultSettingPromise(verificationId, channelId) {
	return apiProcess(getResultSetting, { verificationId, channelId })
}

function generateSEVResultPromise(config, verificationId, channelId, isPcbPkgCascade) {
	return apiProcess(generateSEVResult, { config, verificationId, channelId, isPcbPkgCascade })
}

export {
	getPowerSumResultPromise,
	getResultConfigPromise,
	updateResultConfigPromise,
	getResultSettingPromise,
	generateSEVResultPromise,
}